import { useEffect, useState } from "react";

// A blob: URL for a local File/Blob (e.g. to preview a picked image), revoked
// when the file changes or the component unmounts.
const useObjectUrl = (file: Blob | null | undefined) => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setUrl(null);
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return url;
};

export default useObjectUrl;
